// The in-app page a signed-out visitor asked for, kept through sign-in so a deep link (an email's
// "Review request") lands where it points. Sign-in returns to the same origin (originRedirectUri),
// so sessionStorage carries it.
const RETURN_PATH_KEY = 'eh.returnPath';

// Resolving against a fixed placeholder origin rejects anything that leaves it: `//host`, `/\host`,
// absolute URLs and other schemes all resolve to a different origin.
const PLACEHOLDER_ORIGIN = 'https://hub.invalid';

function safeInAppPath(path: string | null): string | null {
  if (!path?.startsWith('/') || path === '/') return null;
  try {
    return new URL(path, PLACEHOLDER_ORIGIN).origin === PLACEHOLDER_ORIGIN ? path : null;
  } catch {
    return null;
  }
}

export function rememberReturnPath(path: string): void {
  const safe = safeInAppPath(path);
  if (!safe) return;
  try {
    sessionStorage.setItem(RETURN_PATH_KEY, safe);
  } catch {
    // Storage blocked: sign-in lands on the default page, as before.
  }
}

export function peekReturnPath(): string | null {
  try {
    return safeInAppPath(sessionStorage.getItem(RETURN_PATH_KEY));
  } catch {
    return null;
  }
}

export function clearReturnPath(): void {
  try {
    sessionStorage.removeItem(RETURN_PATH_KEY);
  } catch {
    // Nothing to clear when storage is blocked.
  }
}
